import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import List from '../Home/List.jsx'
import { appService } from '../../_services';
import { userService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import { Redirect, Route } from 'react-router-dom';
import ReactGA from 'react-ga';
import ReactIframeResizer from 'react-iframe-resizer-super';

export class ContactSales extends Component {
    displayName = ContactSales.name

    constructor(props) {
        super(props);


    }

    componentDidMount() {

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - Contact sales");
        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }
    }


    render() {

        const meta = {
            title: "Kluwer Law Online - Contact sales",
            canonical: window.location.href,
        }

        const iframeResizerOptions = { checkOrigin: false, maxWidth: '100%', maxHeight: '100%', scrolling: 'true' };

        return (
            <DocumentMeta {...meta}>
                <meta name="viewport" content="width=device-width,height=device-height,initial-scale=1.0" />
            <div>
                <ReactIframeResizer iframeResizerOptions={iframeResizerOptions} src="https://know.wolterskluwerlr.com/KLO-Contact" iframeResizerEnable="true" style={{ width: '100%', height: '100vh', Overflow: 'auto' }}>

                </ReactIframeResizer>
            </div>
            </DocumentMeta >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer Section/ContactSales.jsx